module.exports = __webpack_public_path__ + "img/logo-dark.94c8cb46.gif";